import styled, { css } from "styled-components";

import { DesignTokens, Text } from "melco-ui";

const { spacings, fonts, colors } = DesignTokens;

const StyledText = styled(Text).withConfig({
  shouldForwardProp: (prop) => !["status"].includes(prop),
})<Pick<MachineNameProps, "status">>`
  color: ${colors.gray.dark};
  font-family: ${fonts.sansSerifMd};
  margin-right: ${spacings.xsmall}px;
  ${({ status }) => {
    if (status === "notconnected") {
      return css`
        && {
          color: ${colors.main.negative};
        }
      `;
    }

    if (status === "error") {
      return css`
        && {
          color: ${colors.main.negative};
        }
      `;
    }
    
  }}
`;

type MachineNameProps = {
  name: string;
  status: "running" | "stopped" | "notconnected" | "error";
};

export const MachineName: React.FC<MachineNameProps> = ({ name, status }) => {
  return (
    <StyledText status={status} ellipsis={{ tooltip: name }}>
      {name}
    </StyledText>
  );
};
